<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <form @submit.prevent="onSubmit">
                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Justificativa</label>
                        <input type="text" maxlength="100" v-model="edJustificativa" required v-uppercase />
                    </div>
                </div>

                <div class="row-center">
                    <button type="submit" class="btn-confirm">Confirmar</button>
                    <button @click="closeModal">Retornar</button>
                </div>
            </form>
        </div>
    </div>
</template>
  
<script>
import { ref, computed } from 'vue';

export default {
    props: {visible: {type: Boolean, required: true,},},
    emits: ['update:visible', 'submit'],
        
    setup(props, { emit }) {
        const edJustificativa = ref(null);

        const isVisible = computed(() => props.visible);

        const onSubmit = () => {
            emit('submit', { justificativa: edJustificativa.value });
            closeModal();
        };

        const closeModal = () => {
            emit('update:visible', false);
        };

        return { isVisible, edJustificativa, onSubmit, closeModal };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}
</style>
  